import getDates from "./date.service";

const routeTrtipControlPointService = {
  routes: function (data) {
    return {
      ...data,
      routes: data.routes.map((route) => {
        return {
          ...route,
          dayOffTrips: route.dayOffTrips.map((trip) => {
            return this.trip(trip);
          }),
          workDayTrips: route.workDayTrips.map((trip) => {
            return this.trip(trip);
          }),
        };
      }),
    };
  },
  trip: function (trip) {
    return {
      ...trip,
      start: getDates.timeStringToLocalString(trip.start),
      end: getDates.timeStringToLocalString(trip.end),
      controlPoints: trip.controlPoints.map((controlPoiint) => {
        return {
          ...controlPoiint,
          time: getDates.timeStringToLocalString(controlPoiint.time),
        };
      }),
    };
  },
};

export default routeTrtipControlPointService;
